import React from 'react';
import LegalDocument from './LegalDocument';

/**
 * This component renders the section of terms and conditions for the store admin
 *
 * @return {ReactNode} A React element that renders the section of terms and conditions for the store admin
 */
const GuestTermsCondition = () => {
  return <LegalDocument documentType="terms_conditions" userType="guest" />;
};

export default GuestTermsCondition;
